import React, { useEffect } from 'react';
import styles from './EighthScreen.module.css';
import ScrollReveal from 'scrollreveal';
import Can from '../SecondReceptionistComponents/can/can';
import Button from '../SecondReceptionistComponents/button/Button';

// Importing appropriate icons
import confidenceIcon from '../icons/wired-outline-457-shield-security-hover-pinch.json';
import methodIcon from '../icons/wired-outline-1349-guarantee-hover-pinch.json';
import pricingIcon from '../icons/wired-outline-414-money-bag-dollar-hover-shake.json';
import certificateIcon from '../icons/wired-outline-1349-guarantee-hover-pinch.json';

const EighthScreenRec = () => {
  const benefits = [
    {
      text: 'ביטחון עצמי ומקצועי לעמוד מול בעלי עסקים כשווה בין שווים.',
      icon: confidenceIcon
    },
    {
      text: 'שיטה מסודרת לקליטת לקוחות, ניהול משימות ודיווח חודשי.',
      icon: methodIcon
    },
    {
      text: 'מודל תמחור מדויק שמשקף את הערך האמיתי שלך.',
      icon: pricingIcon
    },
    {
      text: 'תעודת הסמכה מקצועית מבית קרן אקסלרוד – חותמת האיכות שלך בשוק',
      icon: certificateIcon
    }
  ];

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.title}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
    });
  }, []);

  return (
    <section className={styles.container}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>
          אז עם מה ת'כלס תצאי מהקורס?
        </h2>

        <div className={styles.benefitsContainer}>
          {benefits.map((benefit, index) => (
            <Can
              key={index}
              text={benefit.text}
              icon={benefit.icon}
            />
          ))}
        </div>
        
       
      </div>
    </section>
  );
};

export default EighthScreenRec;
